'use strict';

function applyFirebaseTenant(auth, tenantId) {
  if (!auth || typeof auth !== 'object') {
    throw new Error('Firebase Auth instance is required');
  }
  auth.tenantId = tenantId || null;
  return auth;
}

module.exports = { applyFirebaseTenant };
